import {
    GET_SIGNATURE_DOCUMENT_TYPES_START,
    GET_SIGNATURE_DOCUMENT_TYPES_END,
    GET_SIGNATURE_DOCUMENT_TYPES_SUCCESS,
} from "../../../actions/signature/documentTypes";

const initialState = {
    loadings: 0,
    data: {
        size: 0,
        documentTypes: [],
    },
};

export const documentTypesReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_SIGNATURE_DOCUMENT_TYPES_START: {
            return {
                ...state,
                loadings: state.loadings + 1,
            };
        }
        case GET_SIGNATURE_DOCUMENT_TYPES_END: {
            return {
                ...state,
                loadings: state.loadings > 0 ? state.loadings - 1 : 0,
            };
        }
        case GET_SIGNATURE_DOCUMENT_TYPES_SUCCESS: {
            return {
                ...state,
                data: { size: action.documentTypes.length, documentTypes: action.documentTypes },
            };
        }
        default: {
            return state;
        }
    }
};
